import * as actions from '../constants/card_action_types.jsx';

const initialState = {
    cards: [],
    filter: {
        pagesFilter: { pageCount: 1, currentPage: 1, maxItemsOnPage: 1 },
        modelFilter: {
            userName: ""
        },
        sortFilter: {}
    },
    loading: false,
    errors: {},
    forceReload: false
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
    case actions.START_REQUEST:
    {
        return {
            ...state,
            loading: true
        };
    }
    case actions.END_REQUEST:
    {
        return {
            ...state,
            loading: false
        };
    }
    case actions.GET_CARDS:
    {
        return {
            ...state,
            cards: action.cards.items,
            filter: action.cards.filter,
            loading: false,
            errors: {},
            forceReload: false
        };
    }
    case actions.ADD_CARD:
    {
        return {
            ...state,
            cards: [ ...state.cards, action.card ],
            forceReload: true
        };
    }
    case actions.EDIT_CARD:
    {
        return {
            ...state,
            cards: state.cards.map((item, index) => {
                if (item.cardId !== action.card.cardId) {
                    // This isn't the item we care about - keep it as-is
                    return item;
                }

                // Otherwise, this is the one we want - return an updated value
                return {
                    ...item,
                    ...action.item
                };
            }),
            forceReload: true
        };
    }
    default:
        return state;
    }
};